var _this = this;
import * as tslib_1 from "tslib";
import trySaveAndCloseCompose from '../actions/trySaveAndCloseCompose';
import preloadComposePlugins from '../actions/preloadComposePlugins';
import upConvert from '../actions/upConvert';
import { TabType, registerTabHandler } from 'owa-tab-store';
import { PopoutType, registerPopoutHandler, } from 'owa-popout-store';
var composeTabHandler = {
    onActivate: function (viewState) {
        var composeViewState = viewState.data;
        if (composeViewState.isInlineCompose) {
            upConvert(composeViewState);
        }
        preloadComposePlugins(composeViewState);
    },
    canClose: function (viewState) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var composeViewState;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    composeViewState = viewState.data;
                    return [4 /*yield*/, trySaveAndCloseCompose(composeViewState)];
                case 1:
                    _a.sent();
                    // Always return false since trySaveAndCloseCompose() will close compose if it can
                    return [2 /*return*/, false];
            }
        });
    }); },
};
var composePopoutHandler = {
    onActivate: function (viewState) {
        var composeViewState = viewState.data;
        if (composeViewState.isInlineCompose) {
            upConvert(composeViewState);
        }
        preloadComposePlugins(composeViewState);
    },
    canClose: function (viewState) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var composeViewState;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    composeViewState = viewState.data;
                    return [4 /*yield*/, trySaveAndCloseCompose(composeViewState)];
                case 1:
                    _a.sent();
                    // Always return false since trySaveAndCloseCompose() will close compose if it can
                    return [2 /*return*/, false];
            }
        });
    }); },
};
export default function ensureComposeTabHandler() {
    registerTabHandler(TabType.Compose, composeTabHandler);
    registerPopoutHandler(PopoutType.Compose, composePopoutHandler);
}
//# sourceMappingURL=composeTabHandler.js.map